import React, { useState, useEffect } from 'react';

const Spreadsheet = ({ worksheet, cells, apiBaseUrl }) => {
  // Convert cells array to a map for easier access
  const cellsMap = {};
  cells.forEach(cell => {
    const key = `${cell.row_index}-${cell.col_index}`;
    cellsMap[key] = cell;
  });

  // Determine grid dimensions
  const maxRow = Math.max(...cells.map(cell => cell.row_index), 0);
  const maxCol = Math.max(...cells.map(cell => cell.col_index), 0);
  const rows = Math.max(maxRow + 1, 20); // Minimum 20 rows
  const cols = Math.max(maxCol + 1, 10); // Minimum 10 columns

  // Generate column headers (A, B, C, ...)
  const getColumnLabel = (index) => {
    let label = '';
    while (index >= 0) {
      label = String.fromCharCode(65 + (index % 26)) + label;
      index = Math.floor(index / 26) - 1;
    }
    return label;
  };

  // Function to construct full attachment URL
  const getFullAttachmentUrl = (attachmentUrl) => {
    // If it's already a full URL, return as is
    if (attachmentUrl && (attachmentUrl.startsWith('http://') || attachmentUrl.startsWith('https://'))) {
      return attachmentUrl;
    }
    // If it's a relative URL, prepend the correct base URL
    if (attachmentUrl && attachmentUrl.startsWith('/')) {
      return `http://spreadsheets.isilverstar.in${attachmentUrl}`;
    }
    // Otherwise, if we have an apiBaseUrl, use it
    return `${apiBaseUrl || ''}${attachmentUrl}`;
  };

  return (
    <div className="spreadsheet-container overflow-auto border border-gray-300 rounded-lg shadow-sm">
      <table className="spreadsheet-table border-collapse">
        <thead>
          <tr>
            <th className="cell header-cell border border-gray-300 bg-gray-100 w-12 h-8"></th>
            {Array.from({ length: cols }).map((_, colIndex) => (
              <th 
                key={colIndex} 
                className="cell header-cell border border-gray-300 bg-gray-100 w-32 h-8 font-medium"
              >
                {getColumnLabel(colIndex)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              <td className="cell header-cell border border-gray-300 bg-gray-100 w-12 h-8 font-medium">
                {rowIndex + 1}
              </td>
              {Array.from({ length: cols }).map((_, colIndex) => {
                const key = `${rowIndex}-${colIndex}`;
                const cell = cellsMap[key];
                
                return (
                  <td 
                    key={colIndex} 
                    className="cell border border-gray-300 w-32 h-8 p-1 text-sm overflow-hidden relative"
                    style={{ userSelect: 'none' }}
                  >
                    {cell ? (
                      <>
                        {cell.attachment_url ? (
                          <div className="flex items-center">
                            <a 
                              href={getFullAttachmentUrl(cell.attachment_url)} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:text-blue-800"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clipRule="evenodd" />
                              </svg>
                            </a>
                            <span className="ml-1 truncate">{cell.attachment_filename}</span>
                          </div>
                        ) : (
                          <div className="truncate">{cell.content}</div>
                        )}
                      </>
                    ) : null}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Spreadsheet;